import { ReactNode } from 'react';

import { Box } from '@sbv-clients/ui-shared';

const PATHS: Record<string, ReactNode> = {
  punchedIn: (
    <>
      <path d="M10 8l4 4-4 4M14 12H4" />
      <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
    </>
  ),
  hours: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  overtime: <path d="M4 16l5-5 4 4 7-7M15 8h5v5" />,
  warn: (
    <>
      <path d="M12 4 2.8 19.5h18.4z" />
      <path d="M12 10v4.5M12 17.3v.2" />
    </>
  ),
  request: (
    <>
      <rect x="7" y="3.5" width="10" height="17" rx="2" />
      <path d="M11 17.5h2" />
    </>
  ),
  chevron: <path d="m9 6 6 6-6 6" />,
  arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
  up: <path d="m6 15 6-6 6 6" />,
  down: <path d="m6 9 6 6 6-6" />,
};

export type LineIconName = keyof typeof PATHS;

export const LineIcon = ({
  name,
  size = 16,
}: {
  name: LineIconName;
  size?: number;
}) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    aria-hidden
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 1.8,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }}
  >
    {PATHS[name]}
  </Box>
);
